import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  class: "modal fade",
  id: "modalEditSystemTime",
  role: "dialog"
}
const _hoisted_3 = { class: "modal-dialog modal-md" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "modal-title" }, "Schaltzeit anlegen / bearbeiten"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal"
  }, "×")
], -1)
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "form-group row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-lg-2" }, "Typ", -1)
const _hoisted_9 = { class: "col-lg-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Bitte wählen", -1)
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-lg-2" }, "Anlage unscharf", -1)
const _hoisted_15 = { class: "col-lg-10" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-lg-2" }, "Anlage scharf", -1)
const _hoisted_17 = { class: "col-lg-10" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "mt-5" }, "Anwenden auf Wochentag", -1)
const _hoisted_19 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_20 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_21 = ["id", "name", "onUpdate:modelValue"]
const _hoisted_22 = ["for"]
const _hoisted_23 = { class: "modal-footer" }
const _hoisted_24 = {
  class: "modal fade",
  id: "modalCopySystemTimesToSystems",
  role: "dialog"
}
const _hoisted_25 = { class: "modal-dialog modal-md" }
const _hoisted_26 = { class: "modal-content" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "modal-title" }, "Schaltzeiten in andere Anlagen kopieren"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal"
  }, "×")
], -1)
const _hoisted_28 = { class: "modal-body" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "alert alert-danger" }, [
  /*#__PURE__*/_createTextVNode("Die Zeiten werden direkt im Alarmplan und in der Anlage geändert. Haben Sie die Zeiten für "),
  /*#__PURE__*/_createElementVNode("u", null, [
    /*#__PURE__*/_createElementVNode("b", null, "alle")
  ]),
  /*#__PURE__*/_createTextVNode(" Wochentage korrekt eingetragen? Bitte vermeiden Sie mehrfache Änderungen an einem Tag!"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Sie können Schaltzeiten nur in den gleichen Anlagentyp kopieren. ")
], -1)
const _hoisted_30 = { id: "frm_systemTimeCopyToSystems" }
const _hoisted_31 = { class: "custom-control custom-switch custom-control-dark mb-2" }
const _hoisted_32 = ["id", "name", "value", "disabled"]
const _hoisted_33 = ["for"]
const _hoisted_34 = { class: "text-muted" }
const _hoisted_35 = { class: "modal-footer d-flex flex-row justify-content-end align-items-center" }
const _hoisted_36 = {
  class: "modal",
  id: "modalSystemTimeCopy",
  role: "dialog"
}
const _hoisted_37 = { class: "modal-dialog modal-md" }
const _hoisted_38 = { class: "modal-content" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "modal-title" }, "Schaltzeiten kopieren"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal"
  }, "×")
], -1)
const _hoisted_40 = { class: "modal-body" }
const _hoisted_41 = { id: "frm_systemTimeCopy" }
const _hoisted_42 = { class: "custom-control custom-switch custom-control-dark mb-2" }
const _hoisted_43 = ["disabled", "id", "name", "value"]
const _hoisted_44 = ["for"]
const _hoisted_45 = { class: "modal-footer d-flex flex-row justify-content-between align-items-center" }
const _hoisted_46 = {
  class: "modal",
  id: "modalSystemTimeConflict",
  role: "dialog"
}
const _hoisted_47 = { class: "modal-dialog modal-md" }
const _hoisted_48 = { class: "modal-content" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "modal-title" }, "Schaltzeiten Konflikt"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal"
  }, "×")
], -1)
const _hoisted_50 = { class: "modal-body" }
const _hoisted_51 = { class: "media-list media-list-bordered" }
const _hoisted_52 = { class: "mr-3 align-self-center d-flex flex-row align-items-center" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent border-danger text-danger rounded-round border-2 btn-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-alarm-cancel" })
], -1)
const _hoisted_54 = { class: "badge bg-blue ml-3" }
const _hoisted_55 = { class: "media-body align-self-center" }
const _hoisted_56 = { class: "font-weight-bold" }
const _hoisted_57 = { class: "text-muted" }
const _hoisted_58 = { class: "modal-footer d-flex flex-row justify-content-between align-items-center" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", null, "Neue Zeit", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "icon-alarm ml-3" }, null, -1)
const _hoisted_61 = { class: "font-weight-bold mb-4" }
const _hoisted_62 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_63 = /*#__PURE__*/_createStaticVNode("<ul class=\"nav nav-tabs nav-tabs-solid border-0 mt-3 mt-lg-5\"><li class=\"nav-item\"><a class=\"nav-link active\" href=\"#timesChart\" data-toggle=\"tab\" aria-expanded=\"false\"><i class=\"icon-chart mr-1\"></i> Schaltplan</a></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"#timesList\" data-toggle=\"tab\" aria-expanded=\"true\"><i class=\"icon-list mr-1\"></i> Liste</a></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"#ausnahme\" data-toggle=\"tab\" aria-expanded=\"true\"><i class=\"icon-list mr-1\"></i> Ausnahme</a></li></ul>", 1)
const _hoisted_64 = {
  key: 0,
  class: "alert bg-light d-flex justify-content-between align-items-center"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("b", null, "Sie haben noch nicht gesicherte Daten. Bitte drücken Sie auf Schaltzeiten speichern.", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "icon-floppy-disk" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" Jetzt speichern")
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = { class: "card" }
const _hoisted_70 = { class: "tabbable" }
const _hoisted_71 = { class: "tab-content" }
const _hoisted_72 = {
  class: "tab-pane p-0",
  id: "timesList"
}
const _hoisted_73 = { class: "card-header header-elements-inline" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Schaltzeiten", -1)
const _hoisted_75 = { class: "header d-flex flex-row" }
const _hoisted_76 = { class: "btn-group d-md-none" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-sm",
  "data-toggle": "dropdown"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-more2" })
], -1)
const _hoisted_78 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item",
  onclick: "$('#modalEditSystemTime').modal('show')"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-plus3" }),
  /*#__PURE__*/_createTextVNode(" Neue Schaltzeit")
], -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("i", { class: "icon-copy3" }, null, -1)
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" in andere Anlagen kopieren")
const _hoisted_82 = [
  _hoisted_80,
  _hoisted_81
]
const _hoisted_83 = /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1)
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" Alle löschen")
const _hoisted_85 = [
  _hoisted_83,
  _hoisted_84
]
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_87 = ["disabled"]
const _hoisted_88 = /*#__PURE__*/_createElementVNode("i", { class: "icon-floppy-disk" }, null, -1)
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" Schaltzeiten speichern")
const _hoisted_90 = [
  _hoisted_88,
  _hoisted_89
]
const _hoisted_91 = /*#__PURE__*/_createElementVNode("button", {
  id: "btn_modalEditSystemTime",
  type: "button",
  class: "d-none d-md-block btn btn-accent btn-sm mr-1 mr-lg-2 d-flex flex-row flex-nowrap",
  onclick: "$('#modalEditSystemTime').modal('show')"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-plus3" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Neue Schaltzeit")
], -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("i", { class: "icon-copy3" }, null, -1)
const _hoisted_93 = /*#__PURE__*/_createTextVNode()
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Schaltzeiten in andere Anlagen kopieren", -1)
const _hoisted_95 = [
  _hoisted_92,
  _hoisted_93,
  _hoisted_94
]
const _hoisted_96 = /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1)
const _hoisted_97 = /*#__PURE__*/_createTextVNode()
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Alle löschen", -1)
const _hoisted_99 = [
  _hoisted_96,
  _hoisted_97,
  _hoisted_98
]
const _hoisted_100 = {
  class: "media-list media-list-linked media-list-bordered",
  id: "system_timeRows"
}
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3 d-flex flex-column align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent rounded-pill border-2 btn-icon ml-3 mr-3 border-blue text-blue" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fad fa-repeat text-blue" })
  ]),
  /*#__PURE__*/_createElementVNode("small", { class: "text-blue" }, "Intervall")
], -1)
const _hoisted_102 = { class: "media-body align-self-center" }
const _hoisted_103 = { class: "font-weight-bold" }
const _hoisted_104 = { class: "text-muted ml-3" }
const _hoisted_105 = { class: "badge bg-slate" }
const _hoisted_106 = { class: "btn-group d-md-none" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-sm",
  "data-toggle": "dropdown"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-more2" })
], -1)
const _hoisted_108 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_109 = ["onClick"]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("i", { class: "icon-copy3" }, null, -1)
const _hoisted_111 = /*#__PURE__*/_createTextVNode(" Kopieren")
const _hoisted_112 = [
  _hoisted_110,
  _hoisted_111
]
const _hoisted_113 = ["onClick"]
const _hoisted_114 = /*#__PURE__*/_createElementVNode("i", { class: "icon-pen6" }, null, -1)
const _hoisted_115 = /*#__PURE__*/_createTextVNode(" Bearbeiten")
const _hoisted_116 = [
  _hoisted_114,
  _hoisted_115
]
const _hoisted_117 = ["onClick"]
const _hoisted_118 = /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1)
const _hoisted_119 = /*#__PURE__*/_createTextVNode(" Löschen")
const _hoisted_120 = [
  _hoisted_118,
  _hoisted_119
]
const _hoisted_121 = { class: "media-right align-self-center mr-1 d-none d-md-block" }
const _hoisted_122 = ["onClick"]
const _hoisted_123 = /*#__PURE__*/_createElementVNode("i", { class: "icon-pen6" }, null, -1)
const _hoisted_124 = [
  _hoisted_123
]
const _hoisted_125 = { class: "media-right align-self-center d-none d-md-block" }
const _hoisted_126 = ["onClick"]
const _hoisted_127 = /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1)
const _hoisted_128 = [
  _hoisted_127
]
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3 d-flex flex-column align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent rounded-pill border-2 btn-icon ml-3 mr-3 border-success text-success" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-switch" })
  ]),
  /*#__PURE__*/_createElementVNode("small", { class: "text-success" }, "Unscharf")
], -1)
const _hoisted_130 = { class: "media-body align-self-center" }
const _hoisted_131 = { class: "font-weight-bold" }
const _hoisted_132 = { class: "badge bg-slate" }
const _hoisted_133 = { class: "btn-group d-md-none" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-sm",
  "data-toggle": "dropdown"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-more2" })
], -1)
const _hoisted_135 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_136 = ["onClick"]
const _hoisted_137 = /*#__PURE__*/_createElementVNode("i", { class: "icon-copy3" }, null, -1)
const _hoisted_138 = /*#__PURE__*/_createTextVNode(" Kopieren")
const _hoisted_139 = [
  _hoisted_137,
  _hoisted_138
]
const _hoisted_140 = ["onClick"]
const _hoisted_141 = /*#__PURE__*/_createElementVNode("i", { class: "icon-pen6" }, null, -1)
const _hoisted_142 = /*#__PURE__*/_createTextVNode(" Bearbeiten")
const _hoisted_143 = [
  _hoisted_141,
  _hoisted_142
]
const _hoisted_144 = ["onClick"]
const _hoisted_145 = /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1)
const _hoisted_146 = /*#__PURE__*/_createTextVNode(" Löschen")
const _hoisted_147 = [
  _hoisted_145,
  _hoisted_146
]
const _hoisted_148 = { class: "media-right align-self-center mr-1 d-none d-md-block" }
const _hoisted_149 = ["onClick"]
const _hoisted_150 = /*#__PURE__*/_createElementVNode("i", { class: "icon-copy3" }, null, -1)
const _hoisted_151 = [
  _hoisted_150
]
const _hoisted_152 = { class: "media-right align-self-center mr-1 d-none d-md-block" }
const _hoisted_153 = ["onClick"]
const _hoisted_154 = /*#__PURE__*/_createElementVNode("i", { class: "icon-pen6" }, null, -1)
const _hoisted_155 = [
  _hoisted_154
]
const _hoisted_156 = { class: "media-right align-self-center d-none d-md-block" }
const _hoisted_157 = ["onClick"]
const _hoisted_158 = /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1)
const _hoisted_159 = [
  _hoisted_158
]
const _hoisted_160 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3 d-flex flex-column align-items-center" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent rounded-pill border-2 btn-icon ml-3 mr-3 border-danger text-danger" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-switch" })
  ]),
  /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "Scharf")
], -1)
const _hoisted_161 = { class: "media-body align-self-center" }
const _hoisted_162 = { class: "font-weight-bold" }
const _hoisted_163 = { class: "badge bg-slate" }
const _hoisted_164 = { class: "btn-group d-md-none" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-sm",
  "data-toggle": "dropdown"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-more2" })
], -1)
const _hoisted_166 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_167 = ["onClick"]
const _hoisted_168 = /*#__PURE__*/_createElementVNode("i", { class: "icon-copy3" }, null, -1)
const _hoisted_169 = /*#__PURE__*/_createTextVNode(" Kopieren")
const _hoisted_170 = [
  _hoisted_168,
  _hoisted_169
]
const _hoisted_171 = ["onClick"]
const _hoisted_172 = /*#__PURE__*/_createElementVNode("i", { class: "icon-pen6" }, null, -1)
const _hoisted_173 = /*#__PURE__*/_createTextVNode(" Bearbeiten")
const _hoisted_174 = [
  _hoisted_172,
  _hoisted_173
]
const _hoisted_175 = ["onClick"]
const _hoisted_176 = /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1)
const _hoisted_177 = /*#__PURE__*/_createTextVNode(" Löschen")
const _hoisted_178 = [
  _hoisted_176,
  _hoisted_177
]
const _hoisted_179 = { class: "media-right align-self-center mr-1 d-none d-md-block" }
const _hoisted_180 = ["onClick"]
const _hoisted_181 = /*#__PURE__*/_createElementVNode("i", { class: "icon-copy3" }, null, -1)
const _hoisted_182 = [
  _hoisted_181
]
const _hoisted_183 = { class: "media-right align-self-center mr-1 d-none d-md-block" }
const _hoisted_184 = ["onClick"]
const _hoisted_185 = /*#__PURE__*/_createElementVNode("i", { class: "icon-pen6" }, null, -1)
const _hoisted_186 = [
  _hoisted_185
]
const _hoisted_187 = { class: "media-right align-self-center d-none d-md-block" }
const _hoisted_188 = ["onClick"]
const _hoisted_189 = /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1)
const _hoisted_190 = [
  _hoisted_189
]
const _hoisted_191 = {
  key: 1,
  class: "alert alert-info alert-styled-left alert-arrow-left alert-dismissible"
}
const _hoisted_192 = {
  class: "tab-pane active p-0 pb-3",
  id: "timesChart"
}
const _hoisted_193 = { class: "card-header header-elements-inline" }
const _hoisted_194 = /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Schaltzeiten", -1)
const _hoisted_195 = { class: "header d-flex flex-row" }
const _hoisted_196 = { class: "btn-group d-md-none" }
const _hoisted_197 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-sm",
  "data-toggle": "dropdown"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-more2" })
], -1)
const _hoisted_198 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_199 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item",
  onclick: "$('#modalEditSystemTime').modal('show')"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-plus3" }),
  /*#__PURE__*/_createTextVNode(" Neue Schaltzeit")
], -1)
const _hoisted_200 = /*#__PURE__*/_createElementVNode("i", { class: "icon-copy3" }, null, -1)
const _hoisted_201 = /*#__PURE__*/_createTextVNode(" in andere Anlagen kopieren")
const _hoisted_202 = [
  _hoisted_200,
  _hoisted_201
]
const _hoisted_203 = /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1)
const _hoisted_204 = /*#__PURE__*/_createTextVNode(" Alle löschen")
const _hoisted_205 = [
  _hoisted_203,
  _hoisted_204
]
const _hoisted_206 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_207 = ["disabled"]
const _hoisted_208 = /*#__PURE__*/_createElementVNode("i", { class: "icon-floppy-disk" }, null, -1)
const _hoisted_209 = /*#__PURE__*/_createTextVNode(" Schaltzeiten speichern")
const _hoisted_210 = [
  _hoisted_208,
  _hoisted_209
]
const _hoisted_211 = /*#__PURE__*/_createElementVNode("button", {
  id: "btn_modalEditSystemTime",
  type: "button",
  class: "d-none d-md-block btn btn-accent btn-sm mr-1 mr-lg-2 d-flex flex-row flex-nowrap",
  onclick: "$('#modalEditSystemTime').modal('show')"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-plus3" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Neue Schaltzeit")
], -1)
const _hoisted_212 = /*#__PURE__*/_createElementVNode("i", { class: "icon-copy3" }, null, -1)
const _hoisted_213 = /*#__PURE__*/_createTextVNode()
const _hoisted_214 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Schaltzeiten in andere Anlagen kopieren", -1)
const _hoisted_215 = [
  _hoisted_212,
  _hoisted_213,
  _hoisted_214
]
const _hoisted_216 = /*#__PURE__*/_createElementVNode("i", { class: "icon-trash" }, null, -1)
const _hoisted_217 = /*#__PURE__*/_createTextVNode()
const _hoisted_218 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Alle löschen", -1)
const _hoisted_219 = [
  _hoisted_216,
  _hoisted_217,
  _hoisted_218
]
const _hoisted_220 = {
  key: 1,
  class: "alert alert-info alert-styled-left alert-arrow-left alert-dismissible"
}
const _hoisted_221 = {
  class: "tab-pane p-0",
  id: "ausnahme"
}
const _hoisted_222 = {
  key: 1,
  class: "alert alert-info alert-styled-left alert-arrow-left alert-dismissible"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircuitDiagram = _resolveComponent("CircuitDiagram")!
  const _component_Timetable = _resolveComponent("Timetable")!
  const _component_SwitchingExceptions = _resolveComponent("SwitchingExceptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frmNewSystemTime.type) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeSwitchingType && _ctx.changeSwitchingType(...args)))
                }, [
                  _hoisted_10,
                  _createElementVNode("option", {
                    value: "interval",
                    disabled: !_ctx.system.intervalAvailable
                  }, "Intervall", 8, _hoisted_11),
                  _createElementVNode("option", {
                    value: "turnOn",
                    disabled: !_ctx.system.onAvailable
                  }, "Anlage scharf", 8, _hoisted_12),
                  _createElementVNode("option", {
                    value: "turnOff",
                    disabled: !_ctx.system.offAvailable
                  }, "Anlage unscharf", 8, _hoisted_13)
                ], 544), [
                  [_vModelSelect, _ctx.frmNewSystemTime.type]
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["form-group row", { 'd-none': _ctx.frmNewSystemTime.type !== 'interval' && _ctx.frmNewSystemTime.type !== 'turnOff' }])
            }, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  step: "900",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.frmNewSystemTime.off) = $event)),
                  onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validateTimeOnChange && _ctx.validateTimeOnChange(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.frmNewSystemTime.off]
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["form-group row", { 'd-none': _ctx.frmNewSystemTime.type !== 'interval' && _ctx.frmNewSystemTime.type !== 'turnOn' }])
            }, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  step: "900",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.frmNewSystemTime.on) = $event)),
                  onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.validateTimeOnChange && _ctx.validateTimeOnChange(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.frmNewSystemTime.on]
                ])
              ])
            ], 2),
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frmNewSystemTime.weekdays, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "d-flex flex-column align-items-center"
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.weekdaysShort[index]), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: 'wd' + index,
                      name: 'wd' + index,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.frmNewSystemTime.weekdays[index]) = $event)
                    }, null, 8, _hoisted_21), [
                      [_vModelCheckbox, _ctx.frmNewSystemTime.weekdays[index]]
                    ]),
                    _createElementVNode("label", {
                      class: "custom-control-label pl-0",
                      for: 'wd' + index
                    }, null, 8, _hoisted_22)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveSystemTime && _ctx.saveSystemTime(...args)))
            }, "Speichern")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("form", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systems, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "form-group"
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: 'system' + index,
                      name: 'system' + item.anlage_id,
                      value: item.anlage_id,
                      disabled: !item.enabled
                    }, null, 8, _hoisted_32),
                    _createElementVNode("label", {
                      class: "custom-control-label",
                      for: 'system' + index
                    }, [
                      _createTextVNode(_toDisplayString(item.anlage_nummer) + " ", 1),
                      _createElementVNode("span", _hoisted_34, _toDisplayString(item.anlage_bemerkung), 1)
                    ], 8, _hoisted_33)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.copyTimesToSystems && _ctx.copyTimesToSystems(...args)))
            }, "Zeiten kopieren")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("form", _hoisted_41, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.copies, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["form-group", item.disabled ? 'disabled' : ''])
                }, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      disabled: item.disabled,
                      id: 'systemTime' + index,
                      name: 'systemTime' + item.weekday,
                      value: item.timeValue
                    }, null, 8, _hoisted_43),
                    _createElementVNode("label", {
                      class: "custom-control-label",
                      for: 'systemTime' + index
                    }, _toDisplayString(item.weekday), 9, _hoisted_44)
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveCopiedTimes()))
            }, "speichern")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("ul", _hoisted_51, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conflicts, (conflict, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "media bg-white"
                }, [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("span", _hoisted_54, _toDisplayString(conflict.validateTime.weekday), 1)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, _toDisplayString(conflict.validateTime.start.hours) + ":" + _toDisplayString(conflict.validateTime.start.minutes) + " - " + _toDisplayString(conflict.validateTime.end.hours) + ":" + _toDisplayString(conflict.validateTime.end.minutes), 1),
                    _createElementVNode("div", _hoisted_57, " Dauer: " + _toDisplayString(conflict.validateTime.duration.hours) + ":" + _toDisplayString(conflict.validateTime.duration.minutes), 1)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", null, [
              _hoisted_59,
              _hoisted_60,
              _createElementVNode("b", null, _toDisplayString(_ctx.conflictTime), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveAndOverwriteTimes && _ctx.saveAndOverwriteTimes(...args)))
            }, "Zeiten überschreiben")
          ])
        ])
      ])
    ]),
    _createElementVNode("h1", _hoisted_61, _toDisplayString(_ctx.headline) + ": " + _toDisplayString(_ctx.systems[_ctx.systemId]?.anlage_bemerkung), 1),
    (!_ctx.system.intervalAvailable && !_ctx.system.onAvailable && !_ctx.system.offAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_62, " Für diesen Anlagentyp können keine Schaltzeiten konfiguriert werden "))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_63,
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              (_ctx.unsavedChanges)
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    _hoisted_65,
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary btn-sm",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.saveAllSystemTimes && _ctx.saveAllSystemTimes(...args)))
                    }, _hoisted_68)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  (_ctx.system.armingSchedule)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_73, [
                          _hoisted_74,
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, [
                              _hoisted_77,
                              _createElementVNode("div", _hoisted_78, [
                                _hoisted_79,
                                _createElementVNode("a", {
                                  href: "#",
                                  class: "dropdown-item",
                                  disabled: false,
                                  onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showCopyTimesToSystemsModal && _ctx.showCopyTimesToSystemsModal(...args)), ["prevent"]))
                                }, _hoisted_82),
                                _createElementVNode("a", {
                                  href: "#",
                                  class: "dropdown-item",
                                  onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteAllTimes && _ctx.deleteAllTimes(...args)), ["prevent"]))
                                }, _hoisted_85),
                                _hoisted_86,
                                _createElementVNode("a", {
                                  href: "#",
                                  class: _normalizeClass(["dropdown-item", { 'disabled': !_ctx.unsavedChanges }]),
                                  disabled: !_ctx.unsavedChanges,
                                  onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveAllSystemTimes && _ctx.saveAllSystemTimes(...args)), ["prevent"]))
                                }, _hoisted_90, 10, _hoisted_87)
                              ])
                            ]),
                            _hoisted_91,
                            _createElementVNode("button", {
                              id: "btn_copySystemTimes",
                              type: "button",
                              class: "d-none d-md-block btn btn-accent btn-sm mr-1 mr-lg-2",
                              disabled: false,
                              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.showCopyTimesToSystemsModal && _ctx.showCopyTimesToSystemsModal(...args)))
                            }, _hoisted_95),
                            _createElementVNode("button", {
                              id: "btn_deleteSystemTimes",
                              type: "button",
                              class: "d-none d-md-block btn btn-danger btn-sm mr-1 mr-lg-2",
                              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.deleteAllTimes && _ctx.deleteAllTimes(...args)))
                            }, _hoisted_99)
                          ])
                        ]),
                        _createElementVNode("ul", _hoisted_100, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.switchingTimes.interval, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index,
                              class: "media"
                            }, [
                              _hoisted_101,
                              _createElementVNode("div", _hoisted_102, [
                                _createElementVNode("div", _hoisted_103, [
                                  _createTextVNode(_toDisplayString(item.validateTime.start.hours) + ":" + _toDisplayString(item.validateTime.start.minutes) + " - " + _toDisplayString(item.validateTime.end.hours) + ":" + _toDisplayString(item.validateTime.end.minutes) + " ", 1),
                                  _createElementVNode("span", _hoisted_104, " ( " + _toDisplayString(item.validateTime.duration.hours) + ":" + _toDisplayString(item.validateTime.duration.minutes) + " Stunden ) ", 1)
                                ]),
                                _createElementVNode("span", _hoisted_105, _toDisplayString(item.validateTime.weekday), 1)
                              ]),
                              _createElementVNode("div", _hoisted_106, [
                                _hoisted_107,
                                _createElementVNode("div", _hoisted_108, [
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.copySwitchingTime(item.weekday, item.validateTime.start.hours + ':' + item.validateTime.start.minutes, item.validateTime.end.hours + ':' + item.validateTime.end.minutes, 'interval'))
                                  }, _hoisted_112, 8, _hoisted_109),
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.editSwitchingTime(item.time, 'interval'))
                                  }, _hoisted_116, 8, _hoisted_113),
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.deleteTime(item, 'interval'))
                                  }, _hoisted_120, 8, _hoisted_117)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_121, [
                                _createElementVNode("button", {
                                  class: "btn bg-primary btn-sm",
                                  onClick: ($event: any) => (_ctx.editSwitchingTime(item.time, 'interval'))
                                }, _hoisted_124, 8, _hoisted_122)
                              ]),
                              _createElementVNode("div", _hoisted_125, [
                                _createElementVNode("button", {
                                  class: "btn bg-danger btn-sm",
                                  onClick: ($event: any) => (_ctx.deleteTime(item, 'interval'))
                                }, _hoisted_128, 8, _hoisted_126)
                              ])
                            ]))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.switchingTimes.on, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index,
                              class: "media"
                            }, [
                              _hoisted_129,
                              _createElementVNode("div", _hoisted_130, [
                                _createElementVNode("div", _hoisted_131, _toDisplayString(item.validateTime.start.hours) + ":" + _toDisplayString(item.validateTime.start.minutes), 1),
                                _createElementVNode("span", _hoisted_132, _toDisplayString(item.validateTime.weekday), 1)
                              ]),
                              _createElementVNode("div", _hoisted_133, [
                                _hoisted_134,
                                _createElementVNode("div", _hoisted_135, [
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.copySwitchingTime(item.weekday, null, item.validateTime.start.hours + ':' + item.validateTime.start.minutes, 'on'))
                                  }, _hoisted_139, 8, _hoisted_136),
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.editSwitchingTime(item.on, 'on'))
                                  }, _hoisted_143, 8, _hoisted_140),
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.deleteTime(item, 'on'))
                                  }, _hoisted_147, 8, _hoisted_144)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_148, [
                                _createElementVNode("button", {
                                  class: "btn bg-light btn-sm",
                                  onClick: ($event: any) => (_ctx.copySwitchingTime(item.weekday, null, item.validateTime.start.hours + ':' + item.validateTime.start.minutes, 'on'))
                                }, _hoisted_151, 8, _hoisted_149)
                              ]),
                              _createElementVNode("div", _hoisted_152, [
                                _createElementVNode("button", {
                                  class: "btn bg-primary btn-sm",
                                  onClick: ($event: any) => (_ctx.editSwitchingTime(item.on, 'on'))
                                }, _hoisted_155, 8, _hoisted_153)
                              ]),
                              _createElementVNode("div", _hoisted_156, [
                                _createElementVNode("button", {
                                  class: "btn bg-danger btn-sm",
                                  onClick: ($event: any) => (_ctx.deleteTime(item, 'on'))
                                }, _hoisted_159, 8, _hoisted_157)
                              ])
                            ]))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.switchingTimes.off, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index,
                              class: "media"
                            }, [
                              _hoisted_160,
                              _createElementVNode("div", _hoisted_161, [
                                _createElementVNode("div", _hoisted_162, _toDisplayString(item.validateTime.start.hours) + ":" + _toDisplayString(item.validateTime.start.minutes), 1),
                                _createElementVNode("span", _hoisted_163, _toDisplayString(item.validateTime.weekday), 1)
                              ]),
                              _createElementVNode("div", _hoisted_164, [
                                _hoisted_165,
                                _createElementVNode("div", _hoisted_166, [
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.copySwitchingTime(item.weekday, item.validateTime.start.hours + ':' + item.validateTime.start.minutes, null, 'off'))
                                  }, _hoisted_170, 8, _hoisted_167),
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.editSwitchingTime(item.off, 'off'))
                                  }, _hoisted_174, 8, _hoisted_171),
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.deleteTime(item, 'off'))
                                  }, _hoisted_178, 8, _hoisted_175)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_179, [
                                _createElementVNode("button", {
                                  class: "btn bg-light btn-sm",
                                  onClick: ($event: any) => (_ctx.copySwitchingTime(item.weekday, item.validateTime.start.hours + ':' + item.validateTime.start.minutes, null, 'off'))
                                }, _hoisted_182, 8, _hoisted_180)
                              ]),
                              _createElementVNode("div", _hoisted_183, [
                                _createElementVNode("button", {
                                  class: "btn bg-primary btn-sm",
                                  onClick: ($event: any) => (_ctx.editSwitchingTime(item.off, 'off'))
                                }, _hoisted_186, 8, _hoisted_184)
                              ]),
                              _createElementVNode("div", _hoisted_187, [
                                _createElementVNode("button", {
                                  class: "btn bg-danger btn-sm",
                                  onClick: ($event: any) => (_ctx.deleteTime(item, 'off'))
                                }, _hoisted_190, 8, _hoisted_188)
                              ])
                            ]))
                          }), 128))
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_191, " Die Funktion steht für diese Anlage nicht zur Verfügung, wenden Sie sich bitte an Ihren Errichter "))
                ]),
                _createElementVNode("div", _hoisted_192, [
                  (_ctx.system.armingSchedule)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_193, [
                          _hoisted_194,
                          _createElementVNode("div", _hoisted_195, [
                            _createElementVNode("div", _hoisted_196, [
                              _hoisted_197,
                              _createElementVNode("div", _hoisted_198, [
                                _hoisted_199,
                                _createElementVNode("a", {
                                  href: "#",
                                  class: "dropdown-item",
                                  disabled: false,
                                  onClick: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showCopyTimesToSystemsModal && _ctx.showCopyTimesToSystemsModal(...args)), ["prevent"]))
                                }, _hoisted_202),
                                _createElementVNode("a", {
                                  href: "#",
                                  class: "dropdown-item",
                                  onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteAllTimes && _ctx.deleteAllTimes(...args)), ["prevent"]))
                                }, _hoisted_205),
                                _hoisted_206,
                                _createElementVNode("a", {
                                  href: "#",
                                  class: _normalizeClass(["dropdown-item", { 'disabled': !_ctx.unsavedChanges }]),
                                  disabled: !_ctx.unsavedChanges,
                                  onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveAllSystemTimes && _ctx.saveAllSystemTimes(...args)), ["prevent"]))
                                }, _hoisted_210, 10, _hoisted_207)
                              ])
                            ]),
                            _hoisted_211,
                            _createElementVNode("button", {
                              id: "btn_copySystemTimes",
                              type: "button",
                              class: "d-none d-md-block btn btn-accent btn-sm mr-1 mr-lg-2",
                              disabled: false,
                              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.showCopyTimesToSystemsModal && _ctx.showCopyTimesToSystemsModal(...args)))
                            }, _hoisted_215),
                            _createElementVNode("button", {
                              id: "btn_deleteSystemTimes",
                              type: "button",
                              class: "d-none d-md-block btn btn-danger btn-sm mr-1 mr-lg-2",
                              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.deleteAllTimes && _ctx.deleteAllTimes(...args)))
                            }, _hoisted_219)
                          ])
                        ]),
                        (_ctx.system.intervalAvailable)
                          ? (_openBlock(), _createBlock(_component_CircuitDiagram, {
                              key: 0,
                              times: _ctx.switchingTimes,
                              onInterval: _ctx.changeInterval,
                              onAddTime: _ctx.addTime,
                              onOnTime: _ctx.changeOnTime,
                              onOffTime: _ctx.changeOffTime,
                              editable: true,
                              onDeleted: _ctx.deletedTime
                            }, null, 8, ["times", "onInterval", "onAddTime", "onOnTime", "onOffTime", "onDeleted"]))
                          : (_openBlock(), _createBlock(_component_Timetable, {
                              key: 1,
                              times: _ctx.switchingTimes,
                              onOnTime: _ctx.changeOnTime,
                              onOffTime: _ctx.changeOffTime,
                              editable: true,
                              onAddTime: _ctx.addTime,
                              onDeleted: _ctx.deletedTime
                            }, null, 8, ["times", "onOnTime", "onOffTime", "onAddTime", "onDeleted"]))
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_220, " Die Funktion steht für diese Anlage nicht zur Verfügung, wenden Sie sich bitte an Ihren Errichter "))
                ]),
                _createElementVNode("div", _hoisted_221, [
                  (_ctx.system.armingBySystem)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.systems && _ctx.systemId)
                          ? (_openBlock(), _createBlock(_component_SwitchingExceptions, {
                              key: 0,
                              systemId: _ctx.systemId,
                              systems: _ctx.systems
                            }, null, 8, ["systemId", "systems"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_222, " Die Funktion steht für diese Anlage nicht zur Verfügung, wenden Sie sich bitte an Ihren Errichter "))
                ])
              ])
            ])
          ])
        ], 64))
  ]))
}